{
  "page": {
    "title": "Auctions",
    "loadingAria": "Loading auctions"
  },
  "loadError": {
    "message": "Could not load the auctions. Please try again.",
    "retry": "Try again"
  },
  "watchlist": {
    "toggleFailed": "Could not update your watchlist. Please try again."
  },
  "mobileSort": {
    "label": "Sort by",
    "ascAria": "Sorting ascending, tap for descending",
    "descAria": "Sorting descending, tap for ascending"
  },
  "tour": {
    "placeBid": {
      "title": "Place a bid",
      "body": "Enter your bid and press 'Bid'. Min bid is pre-filled. You must bid at least 1 CZ$ above the current bid."
    },
    "countdown": {
      "title": "Time left and auto-extension",
      "body": "If a bid takes the lead in the last 10 minutes, the auction extends automatically. Bidding without taking the lead, for example against an auto-bid that counters you, does not extend it."
    }
  },
  "hint": {
    "title": "Win the bid, the rider joins your team",
    "body": "The rider races for you from your next squad selection onward. You are bidding against real managers, not buying at a fixed price.",
    "minBidLabel": "Placing a bid:",
    "minBidBody": "The input is pre-filled with the minimum, at least 1 CZ$ above the current bid. Press Bid and you are in it.",
    "autoExtendLabel": "10-min auto-extension:",
    "autoExtendBody": "A bid that takes the lead in the last 10 minutes extends the auction, so no one can snipe it in the final second.",
    "startTour": "Show me around",
    "jumpToRecommendation": "See an affordable pick"
  },
  "ticker": {
    "bidCount": "{count, plural, one {1 recent bid} other {# recent bids}}"
  },
  "stats": {
    "balance": "Balance",
    "reserved": "Reserved in bids",
    "ridersNow": "Riders now",
    "projection": "Projection"
  },
  "filter": {
    "mySituation": "My auctions ({count})",
    "all": "All ({count})",
    "otherManagers": "Other managers ({count})",
    "wishlistButton": "Wishlist only",
    "feedButton": "Live bids",
    "feedTitleOn": "Hide the live bids panel",
    "feedTitleOff": "Show the live bids panel",
    "searchPlaceholder": "Search riders",
    "searchAria": "Search riders on auction",
    "moreFilters": "More filters"
  },
  "nav": {
    "history": "History"
  },
  "history": {
    "subtitle": "Your completed auctions: bought, sold and lost bids.",
    "tabActive": "Active",
    "tabHistory": "History ({count})",
    "statBought": "Bought",
    "statSold": "Sold",
    "statSpent": "Spent",
    "statEarned": "Earned",
    "filterAll": "All",
    "filterBought": "Bought ({count})",
    "filterSold": "Sold ({count})",
    "emptyWon": "You haven't won any auctions yet",
    "emptySold": "You haven't sold any riders yet",
    "emptyLost": "No lost auctions in your history",
    "emptyAll": "No completed auctions yet",
    "colNation": "Nation",
    "colStatus": "Status",
    "colWinner": "Winner",
    "colBids": "Bids",
    "colPrice": "Price",
    "colTime": "Time",
    "noBids": "No bids",
    "bidsCount": "{count, plural, one {1 bid} other {# bids}}",
    "bidsUniqueBidders": "{count, plural, one {1 team} other {# teams}}",
    "bidWarBadge": "Bid war · {bids, plural, one {1 bid} other {# bids}}, {teams, plural, one {1 team} other {# teams}}",
    "pageOf": "Page {page} of {total}",
    "prev": "Previous",
    "next": "Next",
    "viewBidWar": "View bid war"
  },
  "bidWar": {
    "title": "Bid war: {rider}",
    "subtitle": "Final price {price} CZ$. Every realized bid, now the hammer has fallen.",
    "empty": "No bids were placed on this rider.",
    "winningBid": "Winning bid",
    "fairPlayNote": "Only realized bids are shown here. Auto-bid caps and active strategies always stay private, even after the auction closes."
  },
  "table": {
    "rider": "Rider",
    "nation": "Nation",
    "status": "Status",
    "value": "Value",
    "highestBid": "Highest bid",
    "timeLeft": "Time left",
    "age": "Age",
    "salary": "Salary",
    "potential": "Potential",
    "popularity": "Popularity",
    "popularityTitle": "Fan popularity (0-100). Used by the board's 5-year plan star-rider goal.",
    "reputation": "Reputation",
    "reputationTitle": "Earned race reputation. This is the number the board reads for profile riders.",
    "seller": "Seller",
    "bid": "Bid",
    "ovr": "OVR",
    "ovrTitle": "The weighted average of the abilities his own role needs. The same number means the same level in any role."
  },
  "card": {
    "time": "Time",
    "highestBid": "Highest bid",
    "salary": "Salary",
    "estSalary": "Est. salary",
    "contractExpires": "Exp. after s.{season}",
    "seller": "Seller",
    "potential": "Potential",
    "popularity": "Pop.",
    "reputation": "Rep.",
    "ageYears": "{age} yrs",
    "estValue": "Est. value",
    "ovrTitle": "The weighted average of the abilities his own role needs. The same number means the same level in any role."
  },
  "reputation": {
    "band": {
      "unknown": "Unknown",
      "known": "Known",
      "profile": "Profile",
      "star": "Star",
      "legend": "Legend"
    }
  },
  "leader": {
    "line": "Leading: {name}",
    "none": "No bids yet"
  },
  "overbidHidden": {
    "hideTitle": "Hide this auction from your list",
    "hideAria": "Hide the auction for {name} from your list",
    "showAgain": "Show hidden ({count})"
  },
  "list": {
    "countLine": "Showing {shown} of {total} auctions"
  },
  "timer": {
    "completed": "Completed",
    "expired": "Expired",
    "hoursMinutes": "{h}h {m}m",
    "minutesSeconds": "{m}m {s}s",
    "seconds": "{s}s"
  },
  "badge": {
    "winning": "Winning",
    "seller": "Seller",
    "mine": "Mine",
    "extended": "Ext",
    "flash": "Flash",
    "u23": "U23",
    "u25": "U25",
    "youth": "Youth",
    "firstBidPick": "First pick",
    "outbid": "Outbid · yours {amount}"
  },
  "bidGate": {
    "bothFull": "No room in your academy or senior squad (30/30). Sell a rider to bid.",
    "bothFullU23": "No room on your U23 team ({max}/{max}) or senior squad (30/30). Sell a rider to bid.",
    "bothFullJunior": "No room on your junior team ({max}/{max}) or senior squad (30/30). Sell a rider to bid.",
    "seniorFull": "Your senior squad is full (30/30). Sell a rider to bid.",
    "toSenior": "-> joins your senior squad",
    "toAcademy": "-> joins your academy",
    "toU23": "-> joins your U23 team",
    "toJunior": "-> joins your junior team"
  },
  "bid": {
    "minBid": "Min. {amount} CZ$",
    "minBidCard": "Min. bid: {amount} CZ$",
    "inputAria": "Your bid in CZ$",
    "buttonPlace": "Bid",
    "buttonRaise": "Raise",
    "buttonError": "Error",
    "buttonPlaceAria": "Place bid",
    "buttonRaiseAria": "Raise your bid",
    "sellerLabel": "You're selling",
    "blockedBelowMin": "Raise your bid to at least {amount} CZ$ to bid.",
    "blockedExpired": "This auction has ended. Refresh to see the result.",
    "proxy": {
      "blockedBelowMin": "Your auto-bid limit must be at least {amount} CZ$, the current minimum bid.",
      "blockedExpired": "This auction has ended. Refresh to see the result.",
      "display": "Auto-bid: max {amount} CZ$",
      "help": "I bid up to this for you, 1 CZ$ at a time. You only lose the lead if someone goes above your cap. Your cap stays private.",
      "set": "Set auto-bid limit",
      "edit": "Change auto-bid limit",
      "remove": "Remove auto-bid",
      "save": "Save auto-bid limit",
      "saveButton": "Save",
      "cancel": "Cancel auto-bid editing",
      "placeholder": "Max limit",
      "inputAria": "Auto-bid limit in CZ$",
      "buttonAdd": "+ Auto-bid",
      "buttonAddCard": "+ Set auto-bid limit",
      "editButton": "Change",
      "removeButton": "Remove"
    }
  },
  "section": {
    "leading": "You're leading",
    "overbid": "You've been outbid",
    "selling": "You're selling"
  },
  "empty": {
    "wishlistNoResults": "No active auctions on your wishlisted riders",
    "noInvolvementMySituation": "You're not involved in any active auctions",
    "noResults": "No auctions in this category",
    "wishlistHelp": "Turn off 'Wishlist only' or add riders from the rider overview",
    "browseSuggestion": "Switch to 'All' to browse the market",
    "startAuctionSuggestion": "Go to Riders and start an auction",
    "actionClearWishlist": "Show all auctions",
    "actionBrowseAll": "Browse all auctions",
    "actionStartAuction": "Go to riders"
  },
  "feed": {
    "title": "Live bids · your auctions",
    "empty": "No activity yet on your auctions.",
    "yourBid": "You bid",
    "counterBid": "Counter bid",
    "counterBidNamed": "{name}'s counter-bid",
    "fallbackRider": "Rider",
    "relativeSec": "{n}s ago",
    "relativeMin": "{n}m ago",
    "relativeHour": "{n}h ago"
  },
  "toast": {
    "overbidMessage": "You've been outbid on {riderName}",
    "overbidNewPrice": "New price: {amount} CZ$"
  },
  "modal": {
    "bidTitle": "Confirm bid",
    "bidVerb": "bid",
    "bidAction": "Bid",
    "proxyTitle": "Confirm auto-bid",
    "proxyVerb": "set auto-bid limit to",
    "proxyAction": "Save auto-bid",
    "transferTitle": "Confirm transfer bid",
    "transferVerb": "send a transfer bid of",
    "transferAction": "Send bid",
    "questionPrefix": "Are you sure you want to",
    "onLabel": "on",
    "settlesAfterValueUpdate": "This auction settles after Sunday's value update. Value and abilities can change before it ends.",
    "retirementWarning": {
      "risk": "Nearing the end of his career: this rider is in the retirement window (age {windowStart}-{guaranteedAge}) and may retire after this season.",
      "certain": "This rider is {guaranteedAge} or older and will retire after this season."
    },
    "typoGuard": {
      "title": "Check your price",
      "body": "You're listing <strong>{riderName}</strong> for sale at <strong>{price} CZ$</strong>.",
      "question": "Their market value is <strong>{marketValue} CZ$</strong>. Did you mean that?",
      "confirmButton": "No, my price is intentional",
      "fixButton": "Fix price"
    }
  },
  "fallback": {
    "rider": "rider",
    "team": "a manager"
  },
  "celebration": {
    "title": "You won the auction!",
    "subtitle": "The rider is now on your team"
  },
  "priceChanged": {
    "title": "Price changed",
    "newPrice": "The price is now <strong>{amount} CZ$</strong>.",
    "newMinBid": "The minimum bid is now <strong>{amount} CZ$</strong>. Do you still want to bid?",
    "bidCta": "Bid {amount} CZ$"
  },
  "error": {
    "bidFailed": "The bid could not be placed",
    "proxyFailed": "Failed to set auto-bid",
    "proxyRemoveFailed": "The auto-bid limit could not be removed. It is still active.",
    "insufficientBalance": "Bid exceeds your available balance"
  },
  "warning": {
    "squadCapacity": "Heads up: you are now leading auctions equivalent to {totalAfter} riders (max {maxRiders}). The cap is a hard limit, so you cannot win more riders than your squad can hold."
  },
  "valueDelta": {
    "under": "{pct}% below est. value",
    "over": "{pct}% above est. value",
    "at": "Near est. value",
    "title": "Estimated market value: {amount} CZ$. A model estimate, not a guaranteed price."
  }
}
